import { Component, Input, OnInit, OnChanges } from '@angular/core';

import { DialogService } from 'rev-shared/ui/dialog/Dialog.Service';
import { IMediaFeatures } from 'rev-shared/media/IMediaFeatures';
import { MediaFeaturesService } from 'rev-shared/media/MediaFeatures.Service';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

import styles from './video-basic-info.module.less';

@Component({
	selector: 'video-basic-info',
	templateUrl: './VideoBasicInfo.Component.html'
})
export class VideoBasicInfoComponent implements OnInit, OnChanges {
	@Input() public video: any;

	public readonly styles = styles;
	public mediaFeatures: IMediaFeatures;
	public filteredCustomFields: any[];

	constructor(
		public MediaFeatures: MediaFeaturesService,
		public UserContext: UserContextService,
		private Dialog: DialogService
	) {	}

	public ngOnInit(): void {
		this.MediaFeatures.getFeatures()
			.then(result => this.mediaFeatures = result);
	}

	public ngOnChanges(): void {
		if(this.video) {
			this.filteredCustomFields = (this.video.customFields || []).filter(item => item.value);
		}
	}

	public get isUserAuthenticated(): boolean {
		return this.UserContext.isUserAuthenticated();
	}

	public reportInappropiateVideo(): void {
		this.Dialog.getDialog('ReportVideo').open({
			initialState: {
				video: this.video
			}
		});
	}
}
